import { gql } from 'apollo-boost'

import { TASK_VIEW_FIELDS } from '../fragments/task-view-fields'

const BRAND_DEFINITION_TASK = gql`
  ${TASK_VIEW_FIELDS}
  query brandDefinitionTask($id: ID!) {
    brandDefinitionTask(id: $id) {
      id
      status
      isAwaiting
      awaitingReason
      awaitingReasonComment
      modifiedDate
      reopenedDate
      reopenReason
      currentViewType

      brand {
        id
        name
        website
        isHasNoWebsiteConfirmed
        useBrandNameAsLocationName
        status
        businessStatus
        modifiedDate
        exclusionReason
        locations {
          id
          name
          website
          status
          exclusionReason
          businessStatus
          phone
          coordinates {
            latitude
            longitude
          }
          googlePlaceId
          googleMapsUri
        }
      }
      assignedTo {
        id
        name
      }
      reopenedBy {
        id
        name
      }
      modifiedDate

      miscTaskVerifiedBy {
        id
        name
      }
      miscTaskVerifiedDate
      miscTaskVerifiedComment

      miscTaskQCVerifiedBy {
        id
        name
      }
      miscTaskQCVerifiedDate
      miscTaskQCVerifiedComment
      isAssignable

      relatedTasks {
        brandId
        brandGatewayTask {
          id
          status
          isCurrentViewAutoResolved
          currentViewType
          views {
            ...TaskViewFields
          }
        }
        brandDefinitionTask {
          id
          status
          isCurrentViewAutoResolved
          currentViewType
          views {
            ...TaskViewFields
          }
        }
        menuDefinitionTask {
          id
          status
          isCurrentViewAutoResolved
          currentViewType
          views {
            ...TaskViewFields
          }
        }
      }

      views {
        ...TaskViewFields
        modifiedLocationIdsUnreviewedByDefiner
      }
    }
  }
`

export default BRAND_DEFINITION_TASK
